module.exports = __webpack_public_path__ + "static/img/5.5a961cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting711/images/5.png
// module id = xj/v
// module chunks = 4